<script setup lang="ts">
import getAllProxyCircularsQuery from '@/graphql/getAllProxyCirculars.gql'

const localePath = useLocalePath()
const { t, locale } = useI18n()

defineI18nRoute({
  paths: {
    'en-CA': '/investor-relations/financial-documents/management-proxy-circulars',
    'fr-CA': '/relations-avec-investisseurs/documents-financiers/circulaires-sollicitation-procurations-direction'
  }
})

useHead({
  title: t('navigation.managementProxyCirculars.metatitle'),
  meta: [{ name: 'description', content: t('navigation.managementProxyCirculars.metadescription') }]
})

const { execute: getProxyCirculars } = useApolloFetch(getAllProxyCircularsQuery, 'proxyCirculars')
const proxyCirculars = await getProxyCirculars({ locale: locale.value })

function getCircularLabel(circular: { Year: number, EnglishDocumentOnly: boolean }) {
  return `${t('managementProxyCirculars.pdfLabel')}${circular.EnglishDocumentOnly && locale.value === 'fr-CA' ? ' (disponible en anglais seulement)' : ''}`
}

function getSizeInMB(size: number) {
  return (size / 1024).toFixed(2)
}
</script>

<template>
  <div class="wrapContent">
    <div class="entetePage">
      <div class="wrapper">
        <div class="filAriane">
          <span class="">
            <NuxtLink :to="localePath('index')">{{ $t('navigation.home.name') }}</NuxtLink>
            <span class=""> &gt; </span>
            <NuxtLink :to="localePath('investorRelations-investorRelations')">{{ $t('navigation.investorRelations.name') }}</NuxtLink>
            <span class=""> &gt; </span>
            <NuxtLink :to="localePath('investorRelations-shareholderInformation')">{{ $t('navigation.financialDocuments.name') }}</NuxtLink>
            <span class=""> &gt; </span>
            <span class="">{{ $t('navigation.managementProxyCirculars.name') }}</span>
          </span>
        </div>
        <div class="title">
          <h1><span class="">{{ $t('navigation.managementProxyCirculars.name') }}</span></h1>
        </div>
      </div>
    </div>
    <div class="contentPage">
      <div class="wrapper clearfix">
        <MenuInvestorRelations />
        <div class="contenu right">
          <div class="GpcLibraryExplorer">
            <ul class="GpcLibraryExplorerWrapQueryList">
              <li v-for="circular in proxyCirculars"
                  :key="circular.Year"
                  class="GpcLibraryExplorerWrapQueryListItem">
                <div class="LibraryExplorer_categoryQueryZone_9873204e6ee145339ced4b5af2a0bba3 LibraryExplorerCategoryQueryZone">
                  <div class="LibraryExplorer_categoryContentZone_8b8fde6bfce94f648ba4dd7452eab08e LibraryExplorerCategoryContentZone">
                    <div class="LibraryExplorer_categoryTitleZone_c6933b89d1bf4df0b8ef45febd73b215 LibraryExplorerCategoryTitleZone">
                      <span class="LibraryExplorerCategoryTitle">{{ circular.Year }}</span>
                    </div>
                  </div>
                </div>
                <ul class="GpcLibraryExplorerWrapQueryList">
                  <li class="GpcLibraryExplorerWrapQueryListItem">
                    <div class="LibraryExplorer">
                      <div class="LibraryExplorer_resultContentZone_c7d37efd624c4051a3372fea465d4f4e LibraryExplorerResultContentZone">
                        <div class="LibraryExplorer_contentTitleZone_15bdbfbdceb3486c8b9d3e09dd7775de LibraryExplorerResultTitleZone">
                          <a class="LibraryExplorerResultTitle"
                             :href="circular.Document.url"
                             target="_blank">{{ getCircularLabel(circular) }}</a>
                        </div>
                        <div class="N8ff8c67c7514460088ce1c06f6a95afe separateur">
                          &nbsp;-&nbsp;
                        </div>
                        <div class="LibraryExplorer_contentFileSizeZone_71db956691194556a77e0a146c433822 LibraryExplorerResultFileSizeZone">
                          <span class="LibraryExplorerResultFileSize">{{ getSizeInMB(circular.Document.size) }} Mb</span>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>
